import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import BookmarkStatusRs from '@domain/rs/bookmark/BookmarkStatusRs';
import { PositionBookmarkRs } from '@domain/rs/bookmark/PositionBookmarkRs';
import { JobPostBookmarkRs } from '@domain/rs/bookmark/JobPostBookmarkRs';
import { CompanyBookmarkRs } from '@domain/rs/bookmark/CompnayBookmarkRs';

export default interface BookmarkRepo {
  //북마크 현황 조회
  getBookmarkStatus(): Promise<AxiosResponse<BookmarkStatusRs>>;

  //포지션 북마크 목록 조회
  getPositionBookmarks(): Promise<AxiosResponse<PositionBookmarkRs>>;

  //공고 북마크 목록 조회
  getJobPostBookmarks(): Promise<AxiosResponse<JobPostBookmarkRs>>;

  //기업 북마크 목록 조회
  getCompanyBookmarks(): Promise<AxiosResponse<CompanyBookmarkRs>>;
}

export class RemoteBookmarkRepo implements BookmarkRepo {
  getBookmarkStatus(): Promise<AxiosResponse<BookmarkStatusRs>> {
    return axios.get(`/bookmark/status`);
  }

  getPositionBookmarks(): Promise<AxiosResponse<PositionBookmarkRs>> {
    return axios.get(`/bookmark/positions`);
  }

  getJobPostBookmarks(): Promise<AxiosResponse<JobPostBookmarkRs>> {
    return axios.get(`/bookmark/job-postings`);
  }

  getCompanyBookmarks(): Promise<AxiosResponse<CompanyBookmarkRs>> {
    return axios.get(`/bookmark/companies`);
  }
}
